export const callbackMethods = ['GET', 'POST', 'PUT', 'PATCH', 'DELETE'];
